( function ( $ ) {

    let $sidebar_links;


    $( document ).on( 'accordion_item_toggled', '.accordion-item', function ( e, opening ) {
        e.stopPropagation();
        let id = $(this).attr('id');
        if ( !id ) { return; }
        $sidebar_links.each( function () {
            $(this).toggleClass( 'active', ( opening && $( this ).attr( 'href' ) == `#${id}` ) );
        });
    });


    $( function () {

        $sidebar_links = $( '.sidebar a' );

        $sidebar_links.click( function () {
            let $target_item = $( $(this).attr('href') );
            if ( $target_item.length ) {
                if ( !$target_item.hasClass('open') ) {
                    $( '> .link-wrapper .heading', $target_item ).click();
                }
                $sidebar_links.removeClass('active');
                $(this).addClass('active')
            }
        });

        $('a.more-questions').click( function () {
            let $this = $(this);
            let $list = $( '.accordion-list', $this.closest( '.content' ) );
            let category_id = $this.data().category;
            let offset = $( '.accordion-item.ajax-loaded', $list).length;
            ThemeJS.Functions.send_ajax_request({
                data: {
                    action: 'load_more_faqs',
                    category_id,
                    offset
                },
                success ( response ) {
                    let $new_items = $( '.accordion-item', response.html ).addClass( 'ajax-loaded' );
                    $list.append( $new_items );
                    ThemeJS.Accordions.init_list( $list );
                    if ( !response.more_remaining ) {
                        $this.hide();
                    }
                }
            });
        });

    });


})( jQuery );